// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"493":"73e8f9e8","585":"a606ed15"}[chunkId] + ".css";
};